import { Box, Typography, Link } from "@mui/material";
import React from "react";

export const InitialLegalLanguage = ({ setviewingPrivacyPolicy }: { setviewingPrivacyPolicy: React.Dispatch<boolean> }) => {

  const handlePolicyLink = (e: any) => {
    e.preventDefault();
    setviewingPrivacyPolicy(true)
  }

  return (
    <Box sx={{
      overflowY: "auto",
      maxHeight: "500px",
      display: "flex",
      justifyContent: "space-evenly",
      flexDirection: "column"
    }}>
      <Typography variant='body2'>
        By signing into this system, you are acknowledging that you are an authorized user of the system and/or an authorized recipient of record check results process by your organization through the CARES system.
        <p></p>
        WARNING: Access to this system is restricted to users authorized by Authorized Recipient agencies. Your use of this system may be monitored, recorded and subject to audit. By signing into this system, you agree to the following <Link data-testid="privacy-policy-security-policy-link" style={{ cursor: "pointer" }}
          onClick={(handlePolicyLink)}>Privacy Policy and Security Policy.</Link>
        <br></br>
        Unauthorized access and misuse of the system is a violation of state and federals laws, regulations and policies. Violators may be subject to prosecution and/or civil liability.
      </Typography>
    </Box>
  )
}